import { buildCloudinaryURL, generateAllBreakpointSrcSet } from './cloudinary';
import type { SrcSetWidths } from './cloudinary';

type CloudinaryImageRenderProps = {
    src: string;
    srcSet: string;
};

type CloudinaryImageProps = {
    imagePath: string;
    width?: number;
    breakpointWidthOverrides?: SrcSetWidths;
    render?: (props: CloudinaryImageRenderProps) => JSX.Element;
};

export function CloudinaryImage({
    imagePath,
    width,
    breakpointWidthOverrides,
    render = (props) => <img src={props.src} srcSet={props.srcSet} alt="" role="presentation" />,
}: CloudinaryImageProps) {
    const src = buildCloudinaryURL(imagePath, { width });
    const srcSet = generateAllBreakpointSrcSet(imagePath, breakpointWidthOverrides);

    return render({ src, srcSet });
}
